document.addEventListener('click', function (event) {
  var closeButton = event.target.closest('[data-close-details]');

  if (!closeButton) {
    return;
  }

  var details = closeButton.closest('details');

  if (details) {
    details.open = false;
  }
});

document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
  var slides = gallery.querySelectorAll('[data-gallery-slide]');
  var current = gallery.querySelector('[data-gallery-current]');
  var previous = gallery.querySelector('[data-gallery-prev]');
  var next = gallery.querySelector('[data-gallery-next]');
  var activeIndex = 0;

  function showMedia(mediaId) {
    var activeNumber = '01';

    slides.forEach(function (slide, index) {
      var isActive = slide.getAttribute('data-media-id') === String(mediaId);
      slide.hidden = !isActive;
      slide.classList.toggle('is-active', isActive);

      if (isActive) {
        activeIndex = index;
        activeNumber = String(slide.getAttribute('data-gallery-index') || index + 1).padStart(2, '0');
      }
    });

    if (current) {
      current.textContent = activeNumber;
    }
  }

  function showByOffset(offset) {
    if (!slides.length) {
      return;
    }

    var nextIndex = activeIndex + offset;

    if (nextIndex < 0) {
      nextIndex = slides.length - 1;
    }

    if (nextIndex >= slides.length) {
      nextIndex = 0;
    }

    showMedia(slides[nextIndex].getAttribute('data-media-id'));
  }

  if (previous) {
    previous.addEventListener('click', function () {
      showByOffset(-1);
    });
  }

  if (next) {
    next.addEventListener('click', function () {
      showByOffset(1);
    });
  }

  gallery.showMedia = showMedia;
});

document.querySelectorAll('[data-product-section]').forEach(function (section) {
  var select = section.querySelector('[data-variant-select]');
  var variantsScript = section.querySelector('[data-product-variants]');
  var price = section.querySelector('[data-product-price]');
  var compare = section.querySelector('[data-product-compare]');
  var saving = section.querySelector('[data-product-saving]');
  var button = section.querySelector('[data-add-to-cart]');
  var buttonText = section.querySelector('[data-add-to-cart-text]');
  var hiddenVariantInput = section.querySelector('[data-product-variant-id]');
  var gallery = section.querySelector('[data-product-gallery]');
  var skuTargets = section.querySelectorAll('[data-product-sku]');
  var stockTarget = section.querySelector('[data-product-stock]');
  var locale = section.getAttribute('data-locale') || 'fr-FR';
  var currency = section.getAttribute('data-currency') || 'EUR';
  var addToCartLabel = section.getAttribute('data-add-to-cart-label') || 'Ajouter au panier';
  var soldOutLabel = section.getAttribute('data-sold-out-label') || 'Indisponible';
  var stockInLabel = section.getAttribute('data-stock-in-label') || 'En stock';
  var stockOutLabel = section.getAttribute('data-stock-out-label') || 'Rupture';

  if (!select || !variantsScript) {
    return;
  }

  var variants = [];

  try {
    variants = JSON.parse(variantsScript.textContent);
  } catch (error) {
    variants = [];
  }

  function formatMoney(cents) {
    var value = Number(cents || 0) / 100;

    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency
      }).format(value);
    } catch (error) {
      return value.toFixed(2) + ' ' + currency;
    }
  }

  function getVariant(id) {
    return variants.find(function (variant) {
      return String(variant.id) === String(id);
    });
  }

  function updateVariant() {
    var variant = getVariant(select.value);

    if (!variant) {
      return;
    }

    if (price) {
      price.textContent = formatMoney(variant.price);
    }

    if (compare) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compare.textContent = formatMoney(variant.compare_at_price);
        compare.hidden = false;
      } else {
        compare.hidden = true;
      }
    }

    if (saving) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        saving.textContent = (saving.getAttribute('data-saving-label') || 'Votre économie') + ' : ' + formatMoney(variant.compare_at_price - variant.price);
        saving.hidden = false;
      } else {
        saving.hidden = true;
      }
    }

    if (button && buttonText) {
      button.disabled = !variant.available;
      buttonText.textContent = variant.available ? addToCartLabel : soldOutLabel;
    }

    if (hiddenVariantInput) {
      hiddenVariantInput.value = variant.id;
    }

    skuTargets.forEach(function (target) {
      target.textContent = variant.sku || variant.id;
    });

    if (stockTarget) {
      stockTarget.textContent = variant.available ? stockInLabel : stockOutLabel;
      stockTarget.classList.toggle('is-available', Boolean(variant.available));
      stockTarget.classList.toggle('is-sold-out', !variant.available);
    }

    if (gallery && gallery.showMedia && variant.featured_media && variant.featured_media.id) {
      gallery.showMedia(variant.featured_media.id);
    }

    if (window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }
  }

  select.addEventListener('change', updateVariant);
});
